import { getClient } from "~/src/services/graphql";
import { GRAPHQL_SHIFTSTREAM_ENDPOINT } from "~/src/config";

export const shiftStreamClient = getClient(GRAPHQL_SHIFTSTREAM_ENDPOINT);
